var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TotemSelect',{ref:"sortingSelect",staticClass:"sorter",attrs:{"options":_vm.orders,"placeholder":this.sortingLabel,"type":"sorting","clearable":false,"reduce":({ type, order }) => ({ type, order }),"value":_vm.currentSort,"showSelectedOption":"","width":290},on:{"input":_vm.onSortChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }